import React from 'react';
import C from '../colors';

export const WITHDRAWAL_LIMITS = Object.freeze({
  platformDaily: 50000,
  single: 200,
  userDaily: 2000,
});

const limits = [
  ['单日转账额度', WITHDRAWAL_LIMITS.platformDaily],
  ['单笔转账额度', WITHDRAWAL_LIMITS.single],
  ['单日向单用户转账额度', WITHDRAWAL_LIMITS.userDaily],
];

const money = value => `¥ ${Number(value).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function WithdrawalLimitNotice({ compact = false }) {
  return (
    <div data-testid="withdrawal-limit-notice" style={{ textAlign: 'left', background: '#fff', border: `1px solid ${C.hair}`, borderRadius: 12, padding: compact ? '12px 14px' : '16px 18px' }}>
      <div style={{ marginBottom: compact ? 7 : 10 }}>
        <div style={{ fontFamily: C.sans, fontSize: compact ? 12 : 13, fontWeight: 600, color: C.ink }}>提现额度</div>
        {!compact && <div style={{ marginTop: 4, fontSize: 11.5, color: C.ink3 }}>额度按北京时间自然日累计，实际可用额度以微信为准</div>}
      </div>
      {limits.map(([label, value], index) => (
        <div key={label} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 14, padding: compact ? '6px 0' : '9px 0', borderTop: index === 0 ? `1px solid ${C.hair}` : 'none' }}>
          <span style={{ minWidth: 0, fontSize: compact ? 11 : 12.5, lineHeight: 1.45, color: C.ink3 }}>{label}</span>
          <strong style={{ flexShrink: 0, fontFamily: C.mono, fontSize: compact ? 11 : 13, fontWeight: 600, color: label === '单笔转账额度' ? C.brand2 : C.ink }}>{money(value)}</strong>
        </div>
      ))}
    </div>
  );
}
